module Meevo.Components.Controls {
    "use strict";

    export class MeevoTaxPolicy implements angular.IDirective {
        dataService: Meevo.Components.BaseClasses.DataServiceBase;
        restrict = "E";
        scope = {
            context: "=",
            disabled: "=ngDisabled"

        };

        templateUrl = "app/components/controls/taxPolicyTemplate.html";

        link = ($scope: any, element: any, attributes: any, formCtrl: any) => {
            $scope.taxTypes = [];
            $scope.taxItemRates = [];
            $scope.taxItems = [];
            $scope.repeatedDisplayName = false;
            $scope.defaultTaxRate = 0.00;
            const MAX_TAX_TYPES = 4;

            $scope.initializeTax = () => {

                var taxTypeId = Guid.newSqlSequentialGuid().toString();
                if ($scope.context.selectedSection.model.taxTypes != null)
                    taxTypeId = $scope.context.selectedSection.model
                        .taxTypes[$scope.context.selectedSection.model.taxTypes.length - 1].id;
                else
                    $scope.context.selectedSection.model.taxTypes = [{
                        id: taxTypeId,
                        displayName: "Tax",
                        isActive: true,
                        sortOrder: 1
                    }];

                if ($scope.context.selectedSection.model.taxItems.length >= 1)
                    $scope.defaultTaxRate = $scope.context.selectedSection.model.taxItems[0].taxItemRates[0].taxRate;
                //Create the product, service and membership default Tax type row
                var taxItemIdForDefualtServ = Guid.newSqlSequentialGuid().toString();
                if ($scope.context.selectedSection.model.taxItems.length <= 1) {
                    //add service default
                    $scope.context.selectedSection.model.taxItems.push({
                        id: taxItemIdForDefualtServ,
                        displayName: Meevo.Model.TaxItemTypeEnum[Meevo.Model.TaxItemTypeEnum.Service],
                        taxItemType: Meevo.Model.TaxItemTypeEnum.Service,
                        isDefault: true,
                        isActive: true,
                        sortOrder: $scope.context.selectedSection.model.taxItems.length + 1,
                        taxItemRates: []
                    });
                    $scope.context.selectedSection.model
                        .taxItems[$scope.context.selectedSection.model.taxItems.length - 1].taxItemRates.push({
                            taxRate: $scope.defaultTaxRate,
                            taxItem_LId: taxItemIdForDefualtServ,
                            taxType_LId: taxTypeId
                        });

                    //add product default
                    var taxItemIdForDefualtPro = Guid.newSqlSequentialGuid().toString();
                    $scope.context.selectedSection.model.taxItems.push({
                        id: taxItemIdForDefualtPro,
                        displayName: Meevo.Model.TaxItemTypeEnum[Meevo.Model.TaxItemTypeEnum.Product],
                        taxItemType: Meevo.Model.TaxItemTypeEnum.Product,
                        isDefault: true,
                        isActive: true,
                        sortOrder: $scope.context.selectedSection.model.taxItems.length + 1,
                        taxItemRates: []
                    });
                    $scope.context.selectedSection.model.taxItems[$scope.context.selectedSection.model.taxItems.length - 1].taxItemRates.push({
                        taxRate: $scope.defaultTaxRate,
                        taxItem_LId: taxItemIdForDefualtPro,
                        taxType_LId: taxTypeId
                    });

                    //add membership default
                    var taxItemIdForDefualtMembership = Guid.newSqlSequentialGuid().toString();
                    $scope.context.selectedSection.model.taxItems.push({
                        id: taxItemIdForDefualtMembership,
                        displayName: Meevo.Model.TaxItemTypeEnum[Meevo.Model.TaxItemTypeEnum.Membership],
                        taxItemType: Meevo.Model.TaxItemTypeEnum.Membership,
                        isDefault: true,
                        isActive: true,
                        sortOrder: $scope.context.selectedSection.model.taxItems.length + 1,
                        taxItemRates: []
                    });
                    $scope.context.selectedSection.model.taxItems[$scope.context.selectedSection.model.taxItems.length - 1].taxItemRates.push({
                        taxRate: $scope.defaultTaxRate,
                        taxItem_LId: taxItemIdForDefualtMembership,
                        taxType_LId: taxTypeId
                    });
                }
                _.each($scope.context.selectedSection.model.taxItems,
                    (item: any) => {
                        _.each(item['taxItemRates'],
                            (rate: any) => {
                                let taxType = _.findWhere($scope.context.selectedSection.model.taxTypes, { id: rate['taxType_LId'] })
                                rate['displayName'] = taxType['displayName'];
                                rate['isActive'] = taxType['isActive'];
                            })
                    })

            }

            $scope.initializeTax();

            //add tax type field
            $scope.addTaxType = (name?: string) => {
                var taxTypeId = Guid.newSqlSequentialGuid().toString();
                if ($scope.isAddTaxTypeDisable()) {
                    this.modalService.alert("MESSAGE_ACTIVE_TAXTYPE_LIMIT", 0, true);
                    return;
                }

                $scope.context.selectedSection.model.taxTypes.push({
                    id: taxTypeId,
                    displayName: "",
                    isActive: true,
                    sortOrder: $scope.context.selectedSection.model.taxTypes.length + 1,
                    taxTypeFromDb: 1
                });

                $scope.addTaxRateField(taxTypeId);

                $scope.initializeTax();
            }

            //removing tax type field
            $scope.removeTaxType = (taxItemRate) => {
                const taxModel = $scope.context.selectedSection.model;
                const taxType: any = _.findWhere(taxModel.taxTypes, { id: taxItemRate['taxType_LId'] });

                const continueExecution = () => {
                    const index = taxModel.taxTypes.indexOf(taxType);
                    taxModel.taxTypes[index].isActive = false;
                    const id = taxModel.taxTypes[index].id;                  
                    if (taxModel.taxTypes[index].taxTypeFromDb === 1) {
                        $scope.removeTaxRateField(id);
                        taxModel.taxTypes.splice(index, 1);
                    }
                    if (taxModel.taxAppliedFromTaxTypeId == id) {
                        taxModel.taxAppliedFromTaxTypeId = null;
                    }
                    if (taxModel.taxAppliedOntoTaxTypeId == id) {
                        taxModel.taxAppliedOntoTaxTypeId = null;
                    }
                    $scope.context.selectedSection.taxTypeChanged();
                    $scope.initializeTax();
                };

                if (taxModel.isTaxOnTax && (
                    taxModel.taxAppliedFromTaxTypeId === taxType.id ||
                    taxModel.taxAppliedOntoTaxTypeId === taxType.id)) {
                    this.modalService.confirm("MESSAGE_TAX_ON_TAX_DELETED").then(() => {
                        continueExecution();
                    });
                } else {
                    continueExecution();
                }
            };

            $scope.isAddTaxTypeDisable = (): boolean => {
                let result = _.filter($scope.context.selectedSection.model.taxTypes, (r: any) => { return r.isActive === true })
                return result.length > MAX_TAX_TYPES;
            }

            //Add tax rate field when the tax type field is being added
            $scope.addTaxRateField = (taxTypeId: Guid) => {
                for (var i = 0; i < $scope.context.selectedSection.model.taxItems.length; i++) {
                    $scope.context.selectedSection.model.taxItems[i].taxItemRates.push({
                        taxRate: $scope.defaultTaxRate,
                        taxItem_LId: $scope.context.selectedSection.model.taxItems[i].id,
                        taxType_LId: taxTypeId,
                        isDefault: false,
                        isActive: true
                    });
                }
            }

            //Remove tax rate field when the tax type field is invalid
            $scope.removeTaxRateField = (taxTypeId: Guid) => {
                for (var i = 0; i < $scope.context.selectedSection.model.taxItems.length; i++)
                    for (var j = 0; j < $scope.context.selectedSection.model.taxItems[i].taxItemRates.length; j++)
                        if ($scope.context.selectedSection.model.taxItems[i].taxItemRates[j].taxType_LId == taxTypeId)
                            $scope.context.selectedSection.model.taxItems[i].taxItemRates.splice(j, 1);
            }
            

            //Add tax item
            $scope.addTaxItem = () => {
                var taxItemId = Guid.newSqlSequentialGuid().toString();

                $scope.context.selectedSection.model.taxItems.push({
                    id: taxItemId,
                    displayName: "",
                    taxItemType: 2198,
                    isDefault: false,
                    isActive: true,
                    sortOrder: $scope.context.selectedSection.model.taxItems.length + 1,
                    taxItemRates: [],
                    taxItemFromDb: 1
                });

                for (var i = 0; i < $scope.context.selectedSection.model.taxTypes.length; i++) {
                    let type = $scope.context.selectedSection.model.taxTypes[i];
                    $scope.context.selectedSection.model.taxItems[$scope.context.selectedSection.model.taxItems.length - 1].taxItemRates.push({
                        taxRate: $scope.defaultTaxRate,
                        taxItem_LId: taxItemId,
                        taxType_LId: type.id,
                        displayName: type.displayName,
                        isDefault: false,
                        isActive: type.isActive
                    });
                }
            }
            //Remove TaxItem row
            $scope.removeTaxItem = (taxItem: any) => {
                if (taxItem.taxItemFromDb == undefined) {
                    taxItem.isActive = false;
                }
                else {
                    var index = $scope.context.selectedSection.model.taxItems.indexOf(taxItem);
                    $scope.context.selectedSection.model.taxItems.splice(index, 1);
                }

            }

            $scope.updateTaxType = (taxItemRate) => {   /*  TODO CHECK DUPS HERE*/
                if (taxItemRate.displayName == null) return;

                let taxType: any = _.findWhere($scope.context.selectedSection.model.taxTypes, { id: taxItemRate['taxType_LId'] });
                let index = $scope.context.selectedSection.model.taxTypes.indexOf(taxType);
                $scope.context.selectedSection.model.taxTypes[index].displayName = taxItemRate.displayName;
                $scope.initializeTax();
                $scope.isDisplayNameUnique("taxTypes", taxItemRate);
            }

            $scope.isDisplayNameUnique = (collection: string, item: any) => {
                if (Model.Guard.isNothing(item.displayName)) return;
                let items = _.countBy($scope.context.selectedSection.model[collection], (i: any) => { return i.displayName == item.displayName ? 'Matched' : 'UnMatched' });
                let itemFound = _.filter($scope.context.selectedSection.model[collection], (i: any) => {
                    if (Model.Guard.isNothing(i.displayName)) {
                        return false;
                    } return i.displayName.toLowerCase() == item.displayName.toLowerCase();
                });

                if (itemFound.length > 1) {
                    let message = this.translate.instant("LABEL_TAX_DUPLICATE_NAME", { name: item.displayName });
                    this.modalService.alert(message, Modal.ModalTranslationModes.DoNotTranslate, true)
                        .then((res) => {
                            if (collection == "taxTypes") {
                                let id = item.taxType_LId;
                                let member: any = _.filter($scope.context.selectedSection.model[collection],
                                    (i: any) => { return i.id === id })[0];
                                if (Model.Guard.isSomething(member))
                                    $scope.context.selectedSection.model[collection][member.sortOrder - 1].displayName =
                                        null;
                            } else {
                                let id = item.sortOrder;
                                let member: any = _.filter($scope.context.selectedSection.model[collection],
                                    (i: any) => { return i.sortOrder === id })[0];
                                if (Model.Guard.isSomething(member))
                                    $scope.context.selectedSection.model[collection][member.sortOrder - 1].displayName =
                                        null;
                            }
                            $scope.initializeTax();
                        })
                }
            }

            /*  Undelete TaxItems   */

            $scope.canUndeleteTaxItem = (): boolean => {
                let taxItems = $scope.context.selectedSection.model.taxItems.filter(item => item.isActive === false);
                let taxtypes = $scope.context.selectedSection.model.taxTypes.filter(type => type.isActive === false);
                return taxItems.concat(taxtypes).length > 0;
            }

            $scope.openTaxItemsModal = (): any => {
                let items = _.each($scope.context.selectedSection.model.taxItems.filter((type) => type.taxItemType !== 2251),
                    (item: any) => {
                        _.each(item['taxItemRates'],
                            (rate: any) => {
                                let taxType = _.findWhere($scope.context.selectedSection.model.taxTypes, { id: rate['taxType_LId'] })
                                rate['displayName'] = taxType['displayName'];
                                rate['isActive'] = taxType['isActive'];
                            })
                    })

                let types = _.each($scope.context.selectedSection.model.taxTypes.filter((type) => !type.isActive), () => { });

                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: 'app/plugins/tax/modals/tax.items.modal.html',

                    clickOutsideToClose: true,
                    locals: {
                        tax: { items: items, types: types, taxModel: $scope.context.selectedSection.model }
                    },
                    controller: 'meevo.TaxItems.taxItemsController',
                    controllerAs: 'ctrl'
                }

                this.modalService.showCustom(options).then((res) => {
                    if (res)
                        $scope.initializeTax();
                })
            }


        };

        constructor(private modalService: Meevo.Components.Modal.IModalService, protected appSettings: Meevo.Components.Common.IAppSettings, protected translate: angular.translate.ITranslateService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (modalService: Meevo.Components.Modal.IModalService, appSettings: Meevo.Components.Common.IAppSettings, translate: angular.translate.ITranslateService) => {
                return new MeevoTaxPolicy(modalService, appSettings, translate);
            }
            directive.$inject = ["meevo.components.modal.ModalService", "meevo.AppSettings", "$translate"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoTaxPolicy", MeevoTaxPolicy.factory());
}
